(function() {
const swiperContainers = document.querySelectorAll('.static-reviews-slides-container');

if (swiperContainers.length > 0) {
  function convertBooleanToNumber(value) {
    return value === "true" ? 1 : 0;
  }
  swiperContainers.forEach(swiperContainer => {
    const swiperId = swiperContainer.dataset.swiper_id;
    const navigation = convertBooleanToNumber(swiperContainer.dataset.navigation);
    const autoplay = convertBooleanToNumber(swiperContainer.dataset.autoplay);
    const slide_count = parseFloat(swiperContainer.dataset.slide_count);
    const slide_count_tab = parseFloat(swiperContainer.dataset.slide_count_tab);
    const centeredSlides = convertBooleanToNumber(swiperContainer.dataset.centeredslides);
    const loop = convertBooleanToNumber(swiperContainer.dataset.loop);
    const speed = parseInt(swiperContainer.dataset.speed);

    console.log(centeredSlides);
    
    const static_review = new Swiper(`[data-swiper_id="${swiperId}"] .static-reviews-slides`, {
      observer: true,
      observeParents: true,
      loop: true,
      grabCursor: false,
      loopAddBlankSlides: true,
      keyboard: { enabled: true },
      navigation: {
        nextEl: ".static-reviews-slides-container .swiper-button-next",
        prevEl: ".static-reviews-slides-container .swiper-button-prev",
      },
      initialSlide: 0,
      autoplay: { enabled: autoplay, delay: speed },
      slidesPerView: 1,
      centeredSlides: centeredSlides,
      breakpoints: {
        767: {
          slidesPerView: slide_count_tab,
          centeredSlides: centeredSlides,
        },
        1280: {
          slidesPerView: slide_count,
          centeredSlides: centeredSlides,
        },
        
      }
    });
  });
}

})();

(function() {
  const swiper_Sections = document.querySelectorAll('[data-swiper_id^="swiper__controls_"]');
     
  if (swiper_Sections) {
    
      function convertBooleanToNumber(value) {
        return value === "true" ? 1 : 0;
      }

    swiper_Sections.forEach(swiper_Section => {
      const swiperId = swiper_Section.dataset.swiper_id;
      const navigation = convertBooleanToNumber(swiper_Section.dataset.navigation);
      const autoplay = convertBooleanToNumber(swiper_Section.dataset.autoplay);
      const slide_count = parseFloat(swiper_Section.dataset.slide_count);
      const slide_count_tab = parseFloat(swiper_Section.dataset.slide_count_tab);
      const slide_count_mobile = parseFloat(swiper_Section.dataset.slide_count_mobile);
      const centeredSlides = convertBooleanToNumber(swiper_Section.dataset.centeredslides);
      const loop = convertBooleanToNumber(swiper_Section.dataset.loop);
      const speed = parseInt(swiper_Section.dataset.speed);
      const speed_mobile = parseInt(swiper_Section.dataset.speed_mobile);
      const speed_tab = parseInt(swiper_Section.dataset.speed_tab);
      const spaceBetween = parseInt(swiper_Section.dataset.spacebetween);
      const spaceBetween_mobile = parseInt(swiper_Section.dataset.spacebetween_mobile);
      const pagination = convertBooleanToNumber(swiper_Section.dataset.pagination);
      const autoHeight = convertBooleanToNumber(swiper_Section.dataset.autoheight)
      const paginationType = swiper_Section.dataset.pagination_type;
      const freeMode = swiper_Section.dataset.freemode === "true";
      const effect = swiper_Section.dataset.effect;
      const rows = parseInt(swiper_Section.dataset.rows);
      const rows_mobile = parseInt(swiper_Section.dataset.rows_mobile);
      const allowTouchMove = convertBooleanToNumber(swiper_Section.dataset.allowtouchmove);
      
      const swiper = new Swiper(`[data-swiper_id="${swiperId}"] .swiper__Container`, {
        freeMode: freeMode,
        observer: true,
        observeParents: true,
        autoHeight: autoHeight,
        loop: loop,
        effect: effect,
        grabCursor: true,
        loopAddBlankSlides: true,
        preventClicks: true,
        preventClicksPropagation: true,
        pagination: {
          el: `[data-swiper_id="${swiperId}"] .swiper-pagination`,
          clickable: true,
        },
        keyboard: { enabled: true },
        navigation: {
          nextEl: `[data-swiper_id="${swiperId}"] .swiper-button-next`,
          prevEl: `[data-swiper_id="${swiperId}"] .swiper-button-prev`,
        },
        initialSlide: 0,
        autoplay: { enabled: autoplay, delay: speed },
        slidesPerView: slide_count_mobile,
        grid: {
          rows: rows_mobile,
        },
        centeredSlides: centeredSlides,
        centeredSlidesBounds: centeredSlides,
        spaceBetween: spaceBetween_mobile,
        breakpoints: {
          768: {
            slidesPerView: slide_count_tab,
            centeredSlides: centeredSlides,
            spaceBetween: spaceBetween,
            grid: {
              rows: rows,
            },
          },
          1024: {
            slidesPerView: slide_count,
            centeredSlides: centeredSlides,
            spaceBetween: spaceBetween,
            grid: {
              rows: rows,
            },
          },
        },
      });
    });
  }
})();


class TabsAccordion {
    constructor(selector) {
      this.tabsAccordion = document.querySelector(selector);
      if(!this.tabsAccordion){
        return;
      }
      this.moving_button = this.tabsAccordion.querySelector(".moving_button");
      this.hammer = new Hammer(this.moving_button);
      this.init();
    }

    init(){
      
     if(this.tabsAccordion){
        this.tabButtons = this.tabsAccordion.querySelectorAll('.tab-button');
        this.tabPanels = this.tabsAccordion.querySelectorAll('.tab-panel');
        // Initialize the tabs
        this.tabButtons.forEach((button, index) => {
          button.addEventListener('click', () => {
            const button_text = button.innerHTML;
            this.showTab(index);
            this.moveAnimation(index, button_text);
          });
        });
      }
      this.hammer.on("panleft panright", (ev) => {
        if(ev.isFinal){
          const direction = ev.type === "panright" ? "panright" : "panleft";
          if(direction == "panleft"){
            this.showTab(0);
            this.moveAnimation(0, "Morning");
          }else{
            this.showTab(1);
            this.moveAnimation(1, "Night");
          }
          
        }
      });
    }
    
    showTab(index) {
      this.tabButtons.forEach(button => {
        button.classList.remove('active');
      });
      this.tabPanels.forEach(panel => {
        panel.classList.remove('active');
      });
      this.tabButtons[index].classList.add('active');
      this.tabPanels[index].classList.add('active');
    }

    moveAnimation(index, button_text){
      const indexBase1 = index + 1;
      this.moving_button.dataset.pos = `panel${indexBase1}`;
      this.moving_button.innerHTML = `<span>${button_text}</span>`;
    }
    
    toggleAccordion(index) {
      this.tabPanels[index].classList.toggle('active');
    }
  }

  const tabsAccordion = new TabsAccordion('.tabs');